import React, { useState } from 'react';
import { Wrapper } from '../ServiceProviders/styled';
import CorrectionsList from './components/CorrectionsList';
import Correction from './components/Correction';
import { CORRECTION_MODS } from '../../../../config';

const CorrectionsWrapper = () => {
  const [mode, setMode] = useState(CORRECTION_MODS.LIST);
  const [currentCorrection, setCurrentCorrection] = useState(null);

  const switchMode = (mode, correction) => {
    setMode(mode);
    if (correction) {
      setCurrentCorrection(correction);
    }
  };

  const displayCorrectionComponent = () => {
    switch (mode) {
      case CORRECTION_MODS.LIST:
        return <CorrectionsList handleSwitchMode={switchMode} mode={mode} />;
      case CORRECTION_MODS.ADD:
        return <Correction handleSwitchMode={switchMode} mode={mode} />;
      case CORRECTION_MODS.EDIT:
      case CORRECTION_MODS.INFO:
        return (
          <Correction
            handleSwitchMode={switchMode}
            mode={mode}
            correctionId={currentCorrection.humanId}
          />
        );
      default:
        return <p>Loading...</p>;
    }
  };

  return (
    <Wrapper>
      <div className="border-bottom mb-2">
        <h4 className="header-title">Корректировки стока</h4>
      </div>
      {displayCorrectionComponent()}
    </Wrapper>
  );
};

export default CorrectionsWrapper;
